// 控制台 - 合同管理
// 控制台的：全部、填写中、签署中、已完成、已撤销、已终止、已逾期
// filling/signing/done/cancel/cancel/overdue
export default {
  path: 'contract',
  component: () => import('@/layout/Empty.vue'),
  redirect: 'contract/list',
  children: [
    {
      path: 'list',
      redirect: 'list/all',
      component: () => import('@/views/user/contract/contractList/ContractListMain.vue'),
      meta: {
        title: '签约管理'
      },
      children: ['all', 'fill', 'sign', 'done', 'cancel', 'stop', 'overdue'].map(tab => {
        const pascalCaseName = tab.charAt(0).toUpperCase() + tab.slice(1)
        return {
          path: tab,
          name: 'adminContractList' + pascalCaseName,
          component: () => import(`@/views/user/contract/contractList/ContractList${pascalCaseName}.js`)
        }
      })
    },
    {
      path: 'detail/:id',
      name: 'adminContractDetail',
      component: () => import('@/views/user/contract/ContractDetail.vue'),
      props: true,
      meta: {
        title: '合同详情'
      }
    },
    {
      path: 'preview/:id',
      name: 'adminContractPreview',
      component: () => import('@/views/user/contract/ContractPreview.vue'),
      props: true,
      meta: {
        title: '合同预览',
        layout: {
          name: 'user',
          subPage: true,
          pageWrap: false
        }
      }
    },
    {
      path: 'replenish/:id/:contractId',
      name: 'adminContractReplenish',
      component: () => import('@/views/user/contract/ContractPreview.vue'),
      props: true,
      meta: {
        title: '合同预览',
        layout: {
          name: 'user',
          subPage: true,
          pageWrap: false
        }
      }
    }
  ]
}
